<template>
  <LoadingBlock />
</template>
    
<script setup>
import { useAuth0 } from "@auth0/auth0-vue";

import LoadingBlock from "@/components/LoadingBlock.vue";

const { logout: auth0Logout } = useAuth0();

const logout = function () {
  auth0Logout({ returnTo: window.location.origin })
}

logout()
</script>